module.exports = "img/voip-chevron.bbab537.svg";